export default {
  ar() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'نحن نأسف على عدم استكمال طلبكم. من فضلك قم بالتواصل معنا اذا استمرت المشكلة بالحدوث معك.',
      creditsAndDiscounts: 'Credits & Discounts',
      hotelNotAvailable: '',
      paymentMethod: 'طريقة الدفع',
      placeOrder: 'إدراج الطلب {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'مراجعة طلبك',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'تحديث معلومات الدفع والشحن',
    }
  },
  de() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms: 'Choose Your Payment Terms',
      couldNotProcess: 'Es tut uns leid, aber wir können mit Ihrer Bestellung nicht weiterfahren. Bitte kontaktieren Sie uns, falls das Problem weiter besteht.',
      creditsAndDiscounts: 'Guthaben & Ermäßigungen',
      hotelNotAvailable: '',
      paymentMethod: 'Zahlungsmittel',
      placeOrder: 'Bestellung aufgeben {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Ihre Bestellung überprüfen',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Rechnungs- und Lieferinformationen aktualisieren',
    }
  },
  en() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms: 'Choose Your Payment Terms',
      couldNotProcess: 'Sorry, we could not process your order. Please contact us if the problem continues.',
      creditsAndDiscounts: 'Credits & Discounts',
      hotelNotAvailable: 'Sorry, we were unable to reserve this hotel room. Please select a new one.',
      paymentMethod: 'Payment Method',
      placeOrder: 'Place Order {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Review Your Order',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Update Billing & Shipping Information',
    }
  },
  enGB() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'Sorry, we could not process your order. Please contact us if the problem continues.',
      creditsAndDiscounts: 'Credits & Discounts',
      hotelNotAvailable: 'Sorry, we were unable to reserve this hotel room. Please select a new one.',
      paymentMethod: 'Payment Method',
      placeOrder: 'Place Order {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Review Your Order',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Update Billing & Shipping Information',
    }
  },
  esMX() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'Lo sentimos, no podemos procesar su orden. Favor de contactarnos si el problema continúa.',
      creditsAndDiscounts: 'Créditos & Descuentos',
      hotelNotAvailable: '',
      paymentMethod: 'Método de Pago',
      placeOrder: 'Colocar Orden {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Revise Su Orden',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Actualizar Información de Envío y Facturación',
    }
  },
  fr() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'Désolé, nous n\'avons pas pu traiter votre commande. Si le problème persiste, veuillez nous conctacter.',
      creditsAndDiscounts: 'Credits & Discounts',
      hotelNotAvailable: '',
      paymentMethod: 'Méthode de paiement',
      placeOrder: 'Passer la commande {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Vérifier Votre Commande',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Modifier vos adresses de facturation et de livraison',
    }
  },
  it() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'Ci dispiace, ma non è stato possibile elaborare il tuo ordine. Ti preghiamo di contattarci nel caso in cui il problema dovesse persistere.',
      creditsAndDiscounts: 'Crediti e sconti',
      hotelNotAvailable: '',
      paymentMethod: 'Metodo di pagamento',
      placeOrder: 'Effettua Ordine {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Controlla il tuo ordine',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Aggiorna i dati di fatturazione e di spedizione',
    }
  },
  ja() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: '大変申し訳ございません、ご注文を完了できませんでした。引き続き問題が発生する場合は弊社までご連絡ください。',
      creditsAndDiscounts: 'クレジットと割引',
      hotelNotAvailable: '',
      paymentMethod: '支払い方法',
      placeOrder: '注文する {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: '注文内容を確認する',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: '請求先と発送先の情報を更新',
    }
  },
  pl() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: 'Przepraszamy, nie mogliśmy zrealizować Twojego zamówienia. Prosimy o kontakt, jeśli problem się powtórzy.',
      creditsAndDiscounts: 'Credits & Discounts',
      hotelNotAvailable: '',
      paymentMethod: 'Forma płatności',
      placeOrder: 'złóż zamówienie na {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'sprawdź swoje zamówienie',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: 'Uaktualnij dane do rozliczeń i wysyłki',
    }
  },
  zhCN() {
    return {
      preexistingAccount: 'Looks like you have an account. Login to continue.',
      choosePaymentTerms:'Choose Your Payment Terms',
      couldNotProcess: '抱歉，我们无法处理您的订单。如果问题持续出现请联系我们。',
      creditsAndDiscounts: '积分和折扣',
      hotelNotAvailable: '',
      paymentMethod: '支付方式',
      placeOrder: '下单 {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: '查看您的订单',
      selectRefundable: 'Please select your Refundable Booking preference to continue',
      updateInfo: '更新帐单和发货信息',
    }
  }
}
